import React from "react";

import { Button } from "@app/scripts/react-general-components/Button";
import { Phone } from "@app/scripts/react-general-components/Phone";

import type { AuthStates } from "@app/scripts/types";

type Props = {
  content: any;
  switchForm: React.Dispatch<React.SetStateAction<AuthStates>>;
  bannerImage: JSX.Element;
};

export const AccountCreateForm: React.FC<Props> = ({ content, switchForm, bannerImage }) => (
  <>
    {bannerImage}

    <ui-form>
      <form
        method="post"
        action="/account"
        id="create_customer"
        accept-charset="UTF-8"
        data-login-with-shop-sign-up="true"
        noValidate
        className="create-customer-form"
      >
        <input type="hidden" name="return_to" value="/account/register?submitted=true" />
        <input type="hidden" name="form_type" value="create_customer" />

        <input type="hidden" name="customer[tags]" data-tags />

        <div className="_field half">
          <input
            type="text"
            name="customer[first_name]"
            className="_field__input"
            id="RegisterForm-FirstName_drawer"
            autoComplete="given-name"
            placeholder={content?.register?.first_name}
          />
          <label htmlFor="RegisterForm-FirstName_drawer" className="_field__label">
            {content?.register?.first_name}
          </label>
        </div>

        <div className="_field half">
          <input
            type="text"
            name="customer[last_name]"
            className="_field__input"
            id="RegisterForm-LastName"
            autoComplete="family-name"
            placeholder={content.register.last_name}
          />
          <label htmlFor="RegisterForm-LastName" className="_field__label">
            {content.register.last_name}
          </label>
        </div>

        <div className="_field">
          <input
            type="email"
            name="customer[email]"
            id="RegisterForm-email_drawer"
            className="_field__input"
            spellCheck="false"
            autoCapitalize="off"
            autoComplete="email"
            required
            placeholder={content.register.email}
          />
          <label htmlFor="RegisterForm-email_drawer" className="_field__label">
            {content.register.email}
          </label>
        </div>

        <div className="_field">
          <input
            type="password"
            name="customer[password]"
            id="RegisterForm-password_drawer"
            className="_field__input"
            required
            placeholder={content.register.password}
          />
          <button
            className="_field__button"
            aria-label="form button"
            data-showpassword="RegisterForm-password_drawer"
            type="button"
          >
            <ui-icon name="icon-eye-off"></ui-icon>
          </button>
          <label htmlFor="RegisterForm-password_drawer" className="_field__label">
            {content.register.password}
          </label>

          <div className="password-validation-message mt-1 mb-0"></div>
        </div>

        <Phone name="phone" tag="phone" />

        <div className="_field birthday hide-mobile">
          <input
            id="RegisterFormBday_drawer"
            type="text"
            name="Birthday"
            data-tag="birthday"
            data-format="DD/MM"
            data-validate="birthday"
            className="_field__input"
            placeholder={content?.register?.birthday}
          />
          <label className="_field__label" htmlFor="RegisterFormBday_drawer">
            {content?.register?.birthday}
          </label>
        </div>

        <label className="checkbox">
          <input type="checkbox" name="customer[accepts_marketing]" id="Register_AcceptsMarketing_drawer" />
          <span className="check-bg"></span>
          <ui-icon name="icon-check-small" class="icon-checkmark" width="16" height="16"></ui-icon>
          <span className="checkbox__label" data-label={content.register.accepts_marketing}>
            {content.register.accepts_marketing}
          </span>
        </label>

        <Button label={content?.register?.submit} variant="secondary" type="submit" className="fullwidth" />

        <div className="login__create">
          <span className="text-md text-brand-secondary-grey">{content?.register?.login_text}</span>
          <Button
            onClick={() => switchForm("login")}
            label={content?.register?.login_button}
            variant="text"
            type="submit"
            className="login__forgot-btn button button button--text"
          />
        </div>
      </form>
    </ui-form>
  </>
);
